import * as React from 'react'
import { ScoopSelector } from '../ui'
import styles from './TimeRangeControl.module.scss'

const TIME_RANGE_OPTIONS = [
    { label: 'Most Recent', value: 'Most Recent' },
    { label: 'Last Day', value: 'Last Day' },
    { label: 'Last Week', value: 'Last Week' },
    { label: 'Last Month', value: 'Last Month' },
    { label: 'Last Quarter', value: 'Last Quarter' },
    { label: 'Last Year', value: 'Last Year' },
    { label: 'Next Day', value: 'Next Day' },
    { label: 'Next Week', value: 'Next Week' },
    { label: 'Next Month', value: 'Next Month' },
    { label: 'Next Quarter', value: 'Next Quarter' },
    { label: 'Next Year', value: 'Next Year' },
    { label: 'All', value: 'All' },
    { label: 'Custom', value: 'Custom' },
]

export function TimeRangeControl({
    config,
    setConfig,
    chartProperties,
    onOpenTimeRange,
    controlHeight,
    controlWidth,
}) {
    const handleChange = (event) => {
        if (event.target.value === 'Custom') {
            onOpenTimeRange?.()
        } else {
            if (
                chartProperties &&
                config.selectedItems &&
                config.selectedItems.length === 0 &&
                config.selectedTableColumns.length === 0
            ) {
                chartProperties.series = null
            } else {
                config.timeRange = event.target.value
                if (config.view === 'chart' && chartProperties) chartProperties.getResults(config)
                setConfig({ ...config })
            }
        }
    }

    // Determine size based on controlHeight
    const getSize = () => {
        if (!controlHeight) return 'md'
        if (controlHeight <= 28) return 'xs'
        if (controlHeight <= 36) return 'sm'
        if (controlHeight <= 43) return 'md'
        return 'lg'
    }

    return (
        <ScoopSelector
            value={config.timeRange}
            onChange={handleChange}
            options={TIME_RANGE_OPTIONS}
            label="Time Range"
            size={getSize()}
            className={styles.timeRangeSelector}
            labelClassName={styles.timeRangeLabel}
        />
    )
}
